import { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import {
    FactureAchat,
    FACTURES_ACHATS_FROM_PUBLISHER_REMINDER_DATASOURCE_NAME,
    useAchatsService,
} from '@europrocurement/l2d-domain';
import { DataSource } from '@europrocurement/l2d-redux-utils';
import { AppDispatch } from '../../../../../../redux/types';

/**
 * Hook to manage invoice filtering for reminder publisher
 *
 * @param dataSource - DataSource for invoices
 * @param reminderPublisherFactures - Array of facture references from reminder publisher
 * @returns Function to fetch invoices with applied filters
 */
export function useInvoicesFilter(
    dataSource: DataSource<FactureAchat>,
    reminderPublisherId?: string,
) {
    const { getFactureAchatFromReminderPublisher } = useAchatsService();

    const dispatch = useDispatch<AppDispatch>();

    /**
     * Function to fetch invoices with current filters
     */
    const fetchInvoicesCallback = useCallback(
        () => setTimeout(() => dispatch(getFactureAchatFromReminderPublisher({})), 1500),
        [dispatch, getFactureAchatFromReminderPublisher],
    );

    /**
     * Extract and apply invoice ID filters
     * FILTRE PAR ID OU ID2 NE FONCTIONNE PAS
     */
    useEffect(() => {
        if (reminderPublisherId) {
            dispatch({
                type: `${dataSource.slicename}/set${FACTURES_ACHATS_FROM_PUBLISHER_REMINDER_DATASOURCE_NAME}Filter`,
                payload: {
                    key: 'reminderPublisherFactures.reminderPublisher.id',
                    value: reminderPublisherId,
                },
            });

            fetchInvoicesCallback();
        }

        return () => {
            dispatch({
                type: `${dataSource.slicename}/set${FACTURES_ACHATS_FROM_PUBLISHER_REMINDER_DATASOURCE_NAME}Filter`,
                payload: {
                    key: 'reminderPublisherFactures.reminderPublisher.id',
                    value: undefined,
                },
            });
        };
    }, [dataSource.slicename, dispatch, fetchInvoicesCallback, reminderPublisherId]);

    return {
        fetchInvoicesCallback,
        fetchInvoices: getFactureAchatFromReminderPublisher,
    };
}

export default useInvoicesFilter;
